import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { WiMuleSQL } from "../services/WiMuleSQL";

const fetchMachineDetails = async (url) => {
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "text/plain",
    },
  });

  if (!response.ok) {
    // Handle specific status codes
    if (response.status === 404) {
      throw new Error(
        "No data found for the specified machine and time period."
      );
    }

    // Attempt to read the server's error message
    let errorMessage = "An error occurred while fetching data";
    try {
      const errorData = await response.json();
      errorMessage = errorData.message || errorMessage;
    } catch (e) {
      // If reading the error message fails, use a default message
    }

    throw new Error(errorMessage);
  }

  return response.json();
};

export const useGetMachineDetails = ({ machine, timePeriod }) => {
  const url = useMemo(() => {
    if (!machine) return null; // Return null if machine is invalid
    return `${WiMuleSQL}/api/MachineFaults/GetMachineFaultsDetails?machine=${encodeURIComponent(
      machine
    )}&timePeriod=${encodeURIComponent(timePeriod)}`;
  }, [machine, timePeriod]);

  return useQuery({
    queryKey: ["machineDetails", machine, timePeriod],
    queryFn: () => fetchMachineDetails(url),
    staleTime: 4 * 60 * 60 * 1000, // 4 hours
    refetchOnWindowFocus: false,
    enabled: !!machine, // The query will not automatically run if machine is blank or null
  });
};



const fetchFaultDetails = async (machineId, faultId, timePeriod) => {
  const url = `${WiMuleSQL}/api/MachineFaults/GetFaultDetails?machineId=${encodeURIComponent(machineId)}&faultId=${encodeURIComponent(faultId)}&timePeriod=${encodeURIComponent(timePeriod)}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};

export const useGetFaultDetails = ({ machineId, faultId, timePeriod }) => {
  return useQuery({
    queryKey: ["faultDetails", machineId, faultId, timePeriod],
    queryFn: () => fetchFaultDetails(machineId, faultId, timePeriod),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
